export default __webpack_public_path__ + "static/media/bg_konbini.938a9e25.svg";